import { axiosInstance } from 'src/config/axiosInstance';

class CompanyService {
  static async fetchCompanyUsersList(companyId, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.get(`/users/${companyId}`);
        return response;
      } catch (error) {
        console.error('An error occurred:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
    return [];
  }

  static async fetchCompanyDetails(companyId, maxRetries, retryDelay) {
    let retries = 0;
    while (retries < maxRetries) {
      try {
        const response = await axiosInstance.get(`/companies/${companyId}`);
        return response;
      } catch (error) {
        console.error('Error fetching project details:', error);
        retries++;
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
      }
    }
  }
}

export default CompanyService;
